import React from "react";
import { Box, MainText, PressableOpacity } from "app/components/common";
import { useNavigation } from "@react-navigation/native";
import i18n from "@microdoing/shared/i18n";
import ArrowRightSlider from "../Icons/ArrowSlider/ArrowRightSlider";
import normalize from "app/utils/normalize";
import theme from "app/Theme/Theme";

interface IProps {
  navigationRoute: string;
  navigationCallback?: () => void;
}

const SeeAll = ({ navigationRoute, navigationCallback = () => {} }: IProps) => {
  const navigation = useNavigation();

  const handlePressSeeAll = () => {
    navigationCallback();
    navigation.navigate(navigationRoute);
  };

  return (
    <PressableOpacity onPress={handlePressSeeAll}>
      <Box flexDirection="row" alignItems="center">
        <MainText color="brand.500" variant="l4-medium" marginRight="xxs">
          {i18n.t("see-all")}
        </MainText>
      </Box>
    </PressableOpacity>
  );
};

export default SeeAll;
